import Vue from 'vue'
import i18n from '@/i18n'

Vue.mixin({
  created: function () {
    this.$translate = function (key) {
      return i18n.te(key) ? i18n.t(key) : key
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/translator.js